import { StandaloneCoverBox } from '@/base/components/content/CoverBox';
import { convertLinkFormat } from '@/base/components/content/CoverBox/helpers';
import Feelgood from '@/mabra/public/image/coverbox/feelgood.svg';
import Halsa from '@/mabra/public/image/coverbox/halsa.svg';
import Medicin from '@/mabra/public/image/coverbox/medicin.svg';
import ModeOchSkonhet from '@/mabra/public/image/coverbox/mode-och-skonhet.svg';
import NyttigMat from '@/mabra/public/image/coverbox/nyttig-mat.svg';
import Psykologi from '@/mabra/public/image/coverbox/psykologi.svg';
import Relationer from '@/mabra/public/image/coverbox/relationer.svg';
import Reportage from '@/mabra/public/image/coverbox/reportage.svg';
import Resor from '@/mabra/public/image/coverbox/resor.svg';
import SenasteNytt from '@/mabra/public/image/coverbox/senaste-nytt.svg';
import Traning from '@/mabra/public/image/coverbox/traning.svg';
import Vikt from '@/mabra/public/image/coverbox/vikt.svg';
import { LabradorComponent } from '@/types/component';
import kebabToCamel from '@/utils/kebabToCamel';
import kebabToPascal from '@/utils/kebabToPascal';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { ElementType } from 'react';

const CoverBoxIconsMap: Record<string, ElementType> = {
  Feelgood,
  Halsa,
  Medicin,
  ModeOchSkonhet,
  NyttigMat,
  Psykologi,
  Relationer,
  Reportage,
  Resor,
  SenasteNytt,
  Traning,
  Vikt,
};

const MabraLabradorCoverBox: LabradorComponent = ({ type, meta, data }) => {
  const { hostpath } = meta;

  const camelCaseHostpath = kebabToCamel(hostpath);

  const coverBoxColorVariants = Object.keys(CoverBoxIconsMap).map((key) => key[0].toLowerCase() + key.slice(1));

  const CoverBoxIcon = CoverBoxIconsMap[kebabToPascal(hostpath)];

  return (
    <StandaloneCoverBox
      headline={data.title}
      icon={CoverBoxIcon && <CoverBoxIcon />}
      bodyText={convertLinkFormat(data.bodytext || '')}
      options={{
        variant: 'alternative',
        colors: coverBoxColorVariants.includes(camelCaseHostpath) ? camelCaseHostpath : 'default',
        $headline: { variant: 'none' },
      }}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default MabraLabradorCoverBox;
